import { supabase } from "../supabaseClient.js";

export async function getSession() {
  const { data, error } = await supabase.auth.getSession();
  if (error) throw error;
  return data.session;
}

export async function getCurrentProfile() {
  const session = await getSession();
  if (!session) return null;

  const { data, error } = await supabase
    .from("profiles")
    .select("id, name, role")
    .eq("id", session.user.id)
    .single();

  if (error) throw error;
  return { ...data, email: session.user.email };
}

export async function signInWithPassword(email, password) {
  const { error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) throw error;
}

/**
 * Alta de cuenta. Ojo: el rol NO se manda desde acá a propósito — lo decide
 * el trigger handle_new_user() contra la tabla allowed_signups. Cualquier
 * cosa que se mande en `data` la controla quien se registra, así que no
 * puede influir en los permisos.
 *
 * Devuelve { needsEmailConfirmation: true } cuando Supabase creó el usuario
 * pero todavía no hay sesión porque falta confirmar el correo.
 */
export async function signUpWithPassword(email, password, name) {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: { data: { name } },
  });
  if (error) throw error;
  return { needsEmailConfirmation: !data.session };
}

export async function signOut() {
  await supabase.auth.signOut();
}

/**
 * Manda el correo de recuperación. El link vuelve a la app con un token en el
 * hash de la URL, que supabase-js canjea solo por una sesión temporal; con esa
 * sesión, updatePassword() puede fijar la nueva contraseña.
 *
 * `redirectTo` tiene que estar en Authentication → URL Configuration →
 * Redirect URLs del proyecto, o Supabase ignora el parámetro y usa el Site URL.
 */
export async function sendPasswordReset(email) {
  const { error } = await supabase.auth.resetPasswordForEmail(email.trim(), {
    redirectTo: `${window.location.origin}/`,
  });
  if (error) throw error;
}

export async function updatePassword(password) {
  const { error } = await supabase.auth.updateUser({ password });
  if (error) throw error;
}

/**
 * ¿Estamos volviendo del correo de recuperación? Supabase deja el tipo en el
 * hash (#access_token=...&type=recovery). Hay que mirarlo antes de que
 * supabase-js limpie la URL.
 */
export function isPasswordRecovery() {
  return window.location.hash.includes("type=recovery");
}
